import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "Techinical Knowledge", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", {
  class: "border-black text-center text-2xl",
  "data-hr-content": "",
  style: {"--bg":"white","--p":"0 10px","--trans-x":"-50%","--trans-y":"-50%"}
}, null, -1)
const _hoisted_3 = { class: "table-fixed" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-1/6" }),
    /*#__PURE__*/_createElementVNode("th", { class: "w-1/2" })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TechinicalKnowledgeRow = _resolveComponent("TechinicalKnowledgeRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, header) => {
          return (_openBlock(), _createBlock(_component_TechinicalKnowledgeRow, {
            key: detail.key,
            header: header,
            details: detail
          }, null, 8, ["header", "details"]))
        }), 128))
      ])
    ]),
    _hoisted_5
  ], 64))
}